export enum TabNames {
    Samples = 'Samples',
    Packs = 'Packs',
    Repacks = 'Collections',
}
